export class FilterBaseModel {
    startDate: Date;
    endDate: Date;
    downloading: boolean;
}